import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { HrDialog } from './hr-dialog.component';
import { BTN_DANGER, BTN_SECONDARY, FIELD_ERROR, LABEL, TEXTAREA } from './hr.util';

/** Asks for the reason a reject needs; the caller sends it and closes this on success. */
export const RejectModal: React.FC<{
  employeeName: string;
  saving: boolean;
  onClose: () => void;
  onConfirm: (reason: string) => void;
}> = ({ employeeName, saving, onClose, onConfirm }) => {
  const { t } = useTranslation();
  const [reason, setReason] = useState('');
  const [touched, setTouched] = useState(false);
  const missing = !reason.trim();

  return (
    <HrDialog
      title={t('HR_MODULE.REJECT_DIALOG.TITLE')}
      onClose={onClose}
      footer={
        <>
          <button type="button" className={BTN_SECONDARY} onClick={onClose}>
            {t('HR_MODULE.ACTIONS.CLOSE')}
          </button>
          <button
            type="button"
            className={BTN_DANGER}
            disabled={saving}
            onClick={() => {
              setTouched(true);
              if (!missing) onConfirm(reason.trim());
            }}
          >
            {t('HR_MODULE.ACTIONS.REJECT')}
          </button>
        </>
      }
    >
      <p className="m-0 text-[14px]">
        {t('HR_MODULE.REJECT_DIALOG.MESSAGE', { name: employeeName })}
      </p>
      <label className={LABEL}>
        {t('HR_MODULE.REJECT_DIALOG.REASON')}
        <textarea
          className={TEXTAREA}
          value={reason}
          autoFocus={true}
          maxLength={255}
          onChange={(e) => setReason(e.target.value)}
        />
        {touched && missing ? (
          <span className={FIELD_ERROR}>{t('HR_MODULE.REJECT_DIALOG.REASON_REQUIRED')}</span>
        ) : null}
      </label>
    </HrDialog>
  );
};
